<template>
  <div >
    <topnav />
    <div class="tabs">
      <div class="tab" @click="toggleTab('newshot')" :class="currentTab== 'newshot'? 'active' : '' "><a>新闻动态</a></div>
      <div class="tab" @click="toggleTab('newslast')" :class="currentTab== 'newshot'? '' : 'active' "><a>通知公告</a></div>
    </div>
    <prince :is="currentTab" keep-alive></prince>
  </div>
</template>

<script>
  import topnav from '../components/topnav.vue';
  import newshot from './newshot';
  import newslast from './newslast';
  export default {
    name: 'app',
    data () {
      return {
        currentTab: 'newshot', // currentTab 用于标识当前触发的子组件
      };
    },
    components: { // 声明子组件
      topnav,
      newshot,
      newslast,
    },
    beforeRouteEnter(to,from,next){
      next(e=>{
        e.currentTab=e.$route.query.newsType||"newshot";
      })
    },
   /* beforeRouteUpdate(to,from,next){
      next(e=>{
         e.currentTab=this.$route.query.newsType
       /!* console.log(e.currentTab)
        console.log(e.$route.params)*!/
      })

    },*/

    update(){
      console.log(this.$route.query.newsType)
    },
    mounted(){
      $(".footmenu li").eq(0).addClass('router-link-exact-active').addClass('router-link-active')
    },
    methods: {
      toggleTab: function(tab) {
         if(tab === "newshot"){
          this.$router.push({ path: 'news', query: {newsType:'newshot'}})
        }
        if(tab === "newslast"){
          this.$router.push({ path: 'news', query: {newsType:'newslast'}})
        }
        this.currentTab = tab; // tab 为当前触发标签页的组件名
      }
    }
  }
</script>
<style lang="scss" scoped="">
.tabs{
  height: 1.55rem;
  background-color: rgba(255, 255, 255, 1);
   padding: .35rem .75rem;
  margin-bottom: .5rem;
}
  .tab{
    float: left;
    width: 8.5rem;
    height: 1.4rem;
    border: 0.05rem solid rgba(196, 77, 65, 1);
    text-align: center;
  }
  .tab.active{
    background-color: rgba(196, 77, 65, 1);
  }
 .tab:nth-child(1){
  border-top-left-radius: 0.4rem;
  border-bottom-left-radius: 0.4rem;
}
.tab:nth-child(2){
  border-top-right-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
}
.tab.active a{
  color: rgba(255, 255, 255, 1);
}
  .tab a{
    height:1.5rem;
    line-height: 1.5rem;
    font-size: 0.7rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    color: rgba(196, 77, 65, 1);


  }
</style>



// WEBPACK FOOTER //
// src/view/news.vue